export const MODULE_NAME = 'service-keys';

export const Service = {
    FAKTUROID: 'fakturoid',
    FLEXIBEE: 'flexibee',
};
